// 派单规则
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane :label="$t('common.routine')" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.list')" name="second">
        <div class="grid-height" style="height: calc(100vh - -65px);">
          <vxe-grid
            ref="table-m1" v-bind="vxeOption"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
            @checkbox-all="selectAllEvent"
            @checkbox-change="selectChangeEvent"

            show-overflow height="100%" border="default" :stripe="true" :row-config="{ isHover: true }"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button v-if="sn_auto_engineer_dispatch_add" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">新增
                  </vxe-button>
                  <vxe-button v-if="sn_auto_engineer_dispatch_delete" status="primary" class="button-sty" icon="el-icon-delete"
                              @click="handleDeleteList">批量删除
                  </vxe-button>
                  <vxe-button v-if="sn_auto_engineer_dispatch_export" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button  status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
                        @submit="searchEvent" @reset="searchEvent">

                <vxe-form-item title="工程师" field="name">
                  <template v-slot>
                    <engineer-search :engineer-id.sync="formData.engineerId" style="width: 11vw"/>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="品牌:" field="name">
                  <template v-slot>
                    <brand-select :brand-id.sync="formData.brandId" style="width: 11vw"/>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="产品分类" field="name">
                  <template v-slot>
<!--                    <item-category-select :big-category-id.sync="formData.bigCategoryId"-->
<!--                    :small-category-id.sync="formData.smallCategoryId" style="width: 11vw"/>-->
                    <el-select v-model="formData.bigCategoryId"  clearable>
                      <el-option v-for="item in tableData1" :key="item.id" :label="item.label"
                                 :value="item.id"/>
                    </el-select>
                  </template>
                </vxe-form-item>


                <vxe-form-item title="服务类型" field="name">
                  <template v-slot>
<!--                    <service-type-cascader  @selectedServiceType="data => {formData.serviceTypeId = data}" style="width: 11vw"/>-->
                    <el-select v-model="formData.serviceTypeId"  clearable>
                      <el-option v-for="item in serviceTypeData" :key="item.id" :label="item.label"
                                 :value="item.id"/>
                    </el-select>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="购买渠道" field="name">
                  <template v-slot>
<!--                    <buy-channel-select :buy-channel-id.sync="formData.buyChannelId" style="width: 11vw"/>-->
                    <el-select v-model="formData.buyChannelId"  clearable>
                      <el-option v-for="item in buyDatas" :key="item.id" :label="item.label"
                                 :value="item.id"/>
                    </el-select>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="地区" field="name" >
                  <template v-slot>
                    <el-cascader :props="areaProps" v-model="formData.areaId" :clearable="true"
                                 @change="handleChange" ref="cascaderAddr" style="width: 11vw">
                    </el-cascader>
                  </template>
                </vxe-form-item>

              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import {tableOption} from '@/const/crud/admin/tenant';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import request from "@/router/axios";
import {mapGetters} from "vuex";
import BrandSelect from "@/components/formItem/brandSelect.vue";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import api from "@/api/projectApi";
import store from "@/store";
import {fetchTree} from "@/api/admin/type_tree";
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import {indexPageMixins, siteMixins} from "@/mixins/tabChang";
import ItemCategorySelect from "@/components/formItem/itemCategorySelect.vue";
import BuyChannelSelect from "@/components/formItem/buyChannelSelect.vue";
import EngineerSearch from "@/components/formItem/engineerSearch.vue";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";

export default {
  name: 'sendToEngineer',
  mixins: [indexPageMixins],

  components: {
    EngineerSearch,
    BuyChannelSelect, ItemCategorySelect, BrandSelect, editView, pager,SiteSearch, ServiceTypeCascader},
  data() {
    return {
      total: 0,
      deleteDataUrl: api.snAutoEngineerDispatch.delete,

      //权限
      sn_auto_engineer_dispatch_add:false,
      sn_auto_engineer_dispatch_delete:false,
      sn_auto_engineer_dispatch_export:false,

      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        engineerId: null,
        siteId: null,
        beginDate: '',
        endDate: '',
        areaId: '',
        brandId: '',
        serviceTypeId: null,
        buyChannelId: null,
        bigCategoryId: null,
        smallCategoryId: null,
      },
      tableData1:[],
      buyDatas:[],
      serviceTypeData:[],
      formData: {
        engineerId: null,
        siteId: null,
        siteName: null,
        brandId: '',
        beginDate: '',
        endDate: '',
        areaId: '',
        serviceTypeId: '',
        bigCategoryId: null,
        smallCategoryId: null,
        buyChannelId: null,
      },

      selectionRows: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },

      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      searchDate: null,

      pageSizes: [10, 20, 100],
      columns: [
        {type: "checkbox", title: '', width: 60, resizable: false,},
        {title: this.$t('common.ServiceNetwork'), field: 'siteName', width: 130,},
        {title: this.$t('common.Engineer'), field: 'engineerName', width: 130,},
        {title: this.$t('common.ServiceType'), field: 'serviceTypeName', width: 130,},
        {title: this.$t('common.PurchaseChannel'), field: 'buyChannelName', width: 130,},
        {title: "产品类型", field: 'bigCategoryName', width: 130,},
        {title: this.$t('common.ServiceBrand'), field: 'brandName', width: 110,},
        {title: this.$t('common.district'), field: 'areaNamePath', width: 300,},
        {title: "生效时间", field: 'effectTime', width: 300,},

        {field: 'createTime', title: this.$t('common.CreationTime'), width: 150},
        {title: this.$t('common.founder'), field: 'createBy', width: 150,},
        {width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              if (this.snAutoDispatchDelete){
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.handleDelete(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="删除" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-delete"/>
                    </el-tooltip>
                  </a>
                </div>
              ];
              }
            }
          }
        }
      ]
    };
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.sn_auto_engineer_dispatch_add= this.permissions["sn_auto_engineer_dispatch_add"];
    this.sn_auto_engineer_dispatch_delete = this.permissions["sn_auto_engineer_dispatch_delete"];
    this.sn_auto_engineer_dispatch_export = this.permissions["sn_auto_engineer_dispatch_export"];
  },
  mounted() {
    this.loadItemCategoryTableData();
    this.loadBuyDatas();
    this.loadServerTypeTableData();

  },
  methods: {
    // setSiteData() {
    //   this.formData.siteName = this.currentSiteData.userName
    // },
    loadItemCategoryTableData() {
      this.$http.get('/admin/dict/type/' + '产品分类合并大类').then(res => {
        console.log('字典res',res)
        this.tableData1 = res.data.data
      })
    },

    loadBuyDatas() {
      this.$http.get('/admin/dict/type/' + '购买渠道合并大类').then(res => {
        console.log('字典res',res)
        this.buyDatas = res.data.data
      })
    },
    loadServerTypeTableData() {
      this.$http.get('/admin/dict/type/' + '服务类型合并大类').then(res => {
        console.log('字典res',res)
        this.serviceTypeData = res.data.data
      })
    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },


    // 批量删除
    handleDeleteList() {
      if (this.selectionRows.length === 0) {
        this.$message.warning('请先勾选数据')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.$http({
            url: this.deleteDataUrl,
            method: 'post',
            data: {
              deleteIdList: this.selectionRows
            }
          }).then(res => {
            this.$message.success('删除成功')
            this.getTableData()
          })
        })
      }
    },

    // 单个删除
    handleDelete(id) {
      console.log(id)
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.$http({
          url: this.deleteDataUrl,
          method: 'post',
          data: {
            deleteIdList: [id]
          }
        }).then(res => {
          this.$message.success('删除成功')
          this.getTableData()
        })
      })
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.snAutoEngineerDispatch.getPage,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    doExcle() {
      this.$mask.open()
      this.$objCopy(this.formData, this.requestParam)
      doCheckExcle(fileNames.sendToEngineer).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(api.snAutoEngineerDispatch.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    //全选
    selectAllEvent({checked, records, reserves}) {
      this.selectionRows = records.map(item => item.id)
      console.log(this.selectionRows)
    },

    //单个选中
    selectChangeEvent(data) {
      if (data.checked) {
        this.selectionRows.push(data.row.id)
      } else {
        this.selectionRows = this.selectionRows.filter(item => item !== data.row.id)
      }
      console.log(this.selectionRows)
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },




    // 选中产品大类加载小类
    selectOne() {
      this.formData.smallCategoryId = ''
      this.loadProductOption1()
    },

    // 新增
    openEditDialog(id) {
      console.log(id,);
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      // this.vxeOption.splice(index, 1);
    },

  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }

  ::v-deep .el-cascader--medium {
    width: 13vw;
    height: 38px;
  }

  ::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
    -webkit-box-flex: 1;
    display: inline-block;
    width: 55px;
    -ms-flex-positive: 1;
    flex-grow: 1;
  }

  ::v-deep .el-select>.el-input {
    width: 13vw;
  }

  ::v-deep .vxe-grid .el-input .el-input__inner {
    height: 28px !important;
  }

  // 隐藏搜索框 标题的宽度
  ::v-deep .vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
    font-size: 12px;
    display: inline-block;
    width: 65px !important;
  }
}
::v-deep .tab-box .vxe-grid .vxe-form--item .vxe-form--item-title {
    font-size: 12px;
    display: inline-block;
    width: 60px!important;
}
 .vxe-grid .vxe-form--item .vxe-form--item-title {
  width: 5vw !important;
  margin-left: 16px;
}
</style>
